import { z } from 'zod/v4';

import { normalizePaymentFormWidgetArgs } from './payment-form-widget-args.normalization';
import { partialPaymentFormWidgetDataSchema } from './partial-payment-form-widget-data.schema';

/**
 * The payment form's ONLY tool schema — there is no create twin, see the note in
 * `partial-payment-form-widget-data.schema.ts`. Every other widget type has a pair, so the absence is
 * deliberate and worth spelling out where someone will look for the missing file.
 */
const updatePaymentFormWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the payment-form widget to update.'),
    data: partialPaymentFormWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed. Note fields REPLACES the whole field ' +
            'list, so include every field you want to keep.'
    ),
});

export const updatePaymentFormWidgetArgsSchema = z.preprocess(
    normalizePaymentFormWidgetArgs,
    updatePaymentFormWidgetObjectSchema
);
